/**
 * totp-nudge.tsx — Thẻ nổi nhắc chủ sở hữu bật xác thực 2 lớp (TOTP), cùng kiểu thẻ với lời mời cài app
 * (install-app.tsx#InstallPromoCard). KHÔNG ép buộc — chỉ nhắc; "Để sau" hoãn 7 ngày (xem
 * lib/pwa-install.ts#SNOOZE_DAYS.totp), hiện lại nếu tới lúc đó vẫn chưa bật. Điều phối hiện/ẩn ở entry-prompts.tsx.
 */
import { ShieldAlert, X } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function TotpNudgeCard({ mobile, onClose, onEnable }: { mobile: boolean; onClose: () => void; onEnable: () => void }) {
  return (
    <aside
      role="complementary"
      aria-label="Bật xác thực 2 lớp"
      className={
        mobile
          ? 'fixed inset-x-3 bottom-[calc(3.5rem+env(safe-area-inset-bottom)+0.5rem)] z-40 animate-card-in'
          : 'fixed bottom-5 right-5 z-40 w-[22rem] animate-card-in'
      }
    >
      <div className="relative overflow-hidden rounded-2xl border bg-card shadow-2xl ring-1 ring-amber-500/10">
        <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-amber-500 via-amber-400/60 to-amber-300/20" />
        <button
          type="button"
          onClick={onClose}
          aria-label="Để sau"
          className="absolute right-2 top-3 rounded-md p-1 text-muted-foreground hover:bg-muted hover:text-foreground"
        >
          <X className="h-4 w-4" />
        </button>
        <div className="flex items-start gap-3 p-4 pt-5">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-amber-500/10 text-amber-600 ring-1 ring-amber-500/20">
            <ShieldAlert className="h-6 w-6" />
          </span>
          <div className="min-w-0 flex-1 pr-5">
            <p className="text-sm font-semibold leading-tight">Bật xác thực 2 lớp</p>
            <p className="mt-1 text-xs leading-snug text-muted-foreground">
              Tài khoản chủ sở hữu nên bật xác thực 2 lớp (TOTP) để tăng bảo mật khi đăng nhập — chỉ mất khoảng 1 phút với app Authenticator.
            </p>
          </div>
        </div>
        <div className="flex gap-2 px-4 pb-4">
          <Button className="flex-1" onClick={onEnable}>Bật ngay</Button>
          <Button variant="ghost" onClick={onClose}>Để sau</Button>
        </div>
      </div>
    </aside>
  )
}
